@for (banner of banners(); track banner.id) {
  <tds-banner
    role-type="banner"
    [icon]="banner.icon"
    [variant]="banner.variant"
    [header]="banner.title"
    [subheader]="banner.text"
    (tdsClose)="dismissBanner(banner.id)"
  ></tds-banner>
}

<tds-header>
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>

  <tds-header-title>{{ appName }}</tds-header-title>

  <tds-header-dropdown slot="end" no-dropdown-icon class="user-dropdown">
    <p slot="icon">{{ selectedArea()?.name || ('templates.noArea' | translate) }}</p>
    <h2 id="area-menu-heading" class="header-dropdown-heading">
      {{ 'header.areaMenu' | translate }}
    </h2>
    <tds-header-dropdown-list size="md">
      @for (area of areas(); track area.id) {
        <tds-header-dropdown-list-item
          [selected]="selectedArea()?.id === area.id ? '' : null"
          (click)="selectedArea()?.id !== area.id && changeArea(area.id)"
        >
          <a> {{ area.name }} </a>
        </tds-header-dropdown-list-item>
      }
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-dropdown slot="end" no-dropdown-icon class="user-dropdown">
    <tds-icon slot="icon" name="language" size="20"></tds-icon>
    <h2 id="language-menu-heading" class="header-dropdown-heading">
      {{ 'header.languageMenu' | translate }}
    </h2>
    <tds-header-dropdown-list size="md">
      @if (currentLanguage$ | async; as current) {
        @for (language of languages; track language.value) {
          <tds-header-dropdown-list-item
            [selected]="current.value === language.value ? '' : null"
            (click)="current.value !== language.value && changeTranslation(language.value)"
          >
            <a>
              <span [class]="language.flag"></span>
              <div class="tds-u-pl1">{{ language.name | translate }}</div>
            </a>
          </tds-header-dropdown-list-item>
        }
      }
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-dropdown slot="end" no-dropdown-icon class="user-dropdown">
    @if (userphoto()) {
      <img
        slot="icon"
        [src]="userphoto()"
        alt="User avatar"
        class="user-avatar"
        height="34"
        width="34"
      />
    } @else {
      <tds-icon slot="icon" name="profile"></tds-icon>
    }
    <h2 id="user-menu-heading" class="header-dropdown-heading">
      {{ 'header.userMenu' | translate }}
    </h2>
    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user [header]="username()" [subheader]="useremail()">
      </tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item (click)="toggleTheme()">
        <a>
          @if (theme.isDark()) {
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
              <path
                d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M12 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M12 20v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path
                d="M4.93 4.93l1.41 1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M17.66 17.66l1.41 1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path d="M2 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M20 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path
                d="M4.93 19.07l1.41-1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M17.66 6.34l1.41-1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          } @else {
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
              <g transform="translate(-2 0)">
                <path
                  d="M21 13.2A7.5 7.5 0 0 1 10.8 3 a6.9 6.9 0 1 0 10.2 10.2Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
          }
          <div class="tds-u-pl1">
            {{ (theme.isDark() ? 'theme.light' : 'theme.dark') | translate }}
          </div>
        </a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item (click)="logout()">
        <a>
          <tds-icon name="exit"></tds-icon>
          <div class="tds-u-pl1">{{ 'menu.logout' | translate }}</div>
        </a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield"></a>
  </tds-header-brand-symbol>
</tds-header>
